import { TsDOM as q } from '@/scripts/core/TsDOM'

type TriggerablePopup = HTMLElement & {
	show: (anchorElement: HTMLElement) => void
}

function getTriggerFromEvent(event: Event): HTMLElement | null {
	for (const candidate of event.composedPath()) {
		if (!(candidate instanceof HTMLElement)) continue

		if (candidate.matches('[data-uc-faq-popup-trigger], a[href^="#"]')) {
			return candidate
		}

		const closestTrigger = candidate.closest<HTMLElement>('[data-uc-faq-popup-trigger], a[href^="#"]')
		if (closestTrigger) {
			return closestTrigger
		}
	}

	return null
}

function normalizeTriggerId(raw: string): string {
	return raw
		.trim()
		.toLowerCase()
		.replace(/[^a-z0-9]+/g, '-')
		.replace(/^-+|-+$/g, '')
}

function getTriggerId(trigger: HTMLElement): string | null {
	const explicitTriggerId = trigger.getAttribute('data-uc-faq-popup-trigger')?.trim()

	if (explicitTriggerId) {
		return normalizeTriggerId(explicitTriggerId)
	}

	if (!(trigger instanceof HTMLAnchorElement)) {
		return null
	}

	const href = trigger.getAttribute('href')?.trim()
	if (!href?.startsWith('#') || href.length <= 1) {
		return null
	}

	const rawHash = href.slice(1)
	let decodedHash = rawHash
	try {
		decodedHash = decodeURIComponent(rawHash)
	} catch {
		decodedHash = rawHash
	}

	return normalizeTriggerId(decodedHash)
}

export function initializeFaqPopupTriggers() {
	document.addEventListener('click', (event) => {
		const trigger = getTriggerFromEvent(event)
		if (!trigger) return

		const triggerId = getTriggerId(trigger)
		if (!triggerId) return

		const popup = q.os<TriggerablePopup>(`[data-uc-faq-popup="${triggerId}"]`)
		if (!popup) return

		event.preventDefault()
		popup.show(trigger)
	})
}
